import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { ApiService } from 'app/api.service';
import { DatatableComponent } from '@swimlane/ngx-datatable/src/components/datatable.component';
import * as moment from 'moment';
import * as _ from 'underscore';
declare var alertify: any;

@Component({
  selector: 'app-six-second-board',
  templateUrl: './six-second-board.component.html',
  styleUrls: ['./six-second-board.component.scss']
})
export class SixSecondBoardComponent implements OnInit {

  sixNationsSessionsTrainingList: any = [];
  sixNationsSessionsList: any = [];
  sixNationsSessionsCount: number = 0;
  listCutoff: number = 50;

  @ViewChild('table') table: DatatableComponent;

  constructor(
    // private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private hubService: HubService,
    public apiService: ApiService
  ) {
    // this.loaderService.setLoading();
    this.loaderService.setLoaded();
    // this.updateTable();
  }

  ngOnInit() {
    // this.getSixNationsTrainingList();
    this.updateTable();
  }

  // Update the table
  private updateTable() {
    this.getSixNationsTrainingList();
  }

  private getSixNationsTrainingList() {
    // request options
    // let where = {
    //   "workout": {
    //     "__type": "Pointer",
    //     "className": "Workout",
    //     // "objectId": "1Y4hEb1ibL" // our six nations workout 
    //     "objectId": "DGqZwkS9xI" // 
    //   },
    //   "_created_at" : { 
    //     "$gte": "2020-03-01", 
    //     "$lt": "2020-03-03" 
    // }
    // };

    let where: any = {
      // user: {
      //   className: "_User",
      //   objectId: this.apiService.Parse.User.current().id,
      //   __type: "Pointer"
      // },
      workout: {
        __type: "Pointer",
        className: "Workout",
        // "objectId": "1Y4hEb1ibL" // our six nations workout 
        objectId: "wo-herne-hill-5k" // 
      },
      createdAt: {
        $gte: {
          iso: "2020-03-01",
          __type: "Date"
        },
        $lte: {
          iso: "2020-04-01",
          __type: "Date"
        }
      }
    };

    where = JSON.stringify(where);

    // make the api call
    this.hubService.getResource('RideSessionTraining', where, 500, null, null, null)
      .subscribe(
        response => {
          this.sixNationsSessionsCount = response.length; // how many results do we have
          this.getSixNationsSessionList(response); // get our RideSession Entries
        },
        error => {
          alertify.error(error);
        },
        () => {
          console.log("RideSessionTraining query Completed");
        }
      );
  }

  private getSixNationsSessionList(trainingList) {
    let sessionlist = [];
    for (let i = 0; i < trainingList.length; i++) {
    // for (let i = 0; i < this.listCutoff; i++) {

      let where = {
        "laps": {"$exists":true},
        "training": {
          "__type": "Pointer",
          "className": "RideSessionTraining",
          "objectId": trainingList[i].objectId
        }
      }
      let include = ['user', 'sessionSummary', 'userPerformanceState'];
      this.hubService.getResource('RideSession', where, 1, null, null, include).subscribe(
        rideResponse => {
          this.getLapTwo(rideResponse[0]);
          // console.log(rideResponse[0]);
        },
        error => {
          alertify.error(error);
        });

      // if we've finished getting ridesessions populate the list
      // TODO: now the logic has changed this is in the wrong place
      // if(i == trainingList.length-1){
        //  this.loaderService.setLoaded();
      // }

    }

  }

  getLapTwo(session){
    let body = {
      'objectId': session.objectId,
      'startTime': session.laps[0],
      'endTime': session.laps[1]
    }

    this.hubService.postResource('functions/getRideSessionSegment', body).subscribe(
      response => {
        session['lapTwo'] = response.result;
        session['lapTwo']['summary']['pkg'] = response.result.summary.powerAvg / session.userPerformanceState.weight;
        // if(session['lapTwo'].summary.powerMax){
          this.sixNationsSessionsList.push(session);
          this.sixNationsSessionsList = _.sortBy(this.sixNationsSessionsList, function(o) {
            return o['lapTwo'].summary.pkg;
          })
          this.sixNationsSessionsList.reverse()
        // }
      },
      err => {
        // console.log("error: ", err);
      });

  }

  // Navigate to selected session when the table row is clicked
  onActivate(event) {
    if (event.type == 'click') {
      let target = event.event.target.tagName.toLowerCase();
      if (target != 'label' && target != 'input') {
        this.router.navigate(['/session', event.row.objectId])
      }
    }
  }


}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/six-second-board/six-second-board.component.ts